{
  "title": "Tasha's Mind Whip",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "2nd-level enchantment",
  "level": 2,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V",
  "duration": "1 round",
  "description": [
    "You psychically lash out at one creature you can see within range. The target must make an Intelligence saving throw. On a failed save, the target takes 3d6 psychic damage, and it can’t take a reaction until the end of its next turn. Moreover, on its next turn, it must choose whether it gets a move, an action, or a bonus action; it gets only one of the three. On a successful save, the target takes half as much damage and suffers none of the spell’s other effects.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional creature for each slot level above 2nd. The creatures must be within 30 feet of each other when you target them."
  ],
  "spellLists": ["arcane-trickster", "sorcerer", "wizard"]
}
